/* golfbaanmappen.nl — oriëntatiekiezer (staand/liggend).
   1) Zet de keuze als regel op de bestelling (line item property).
   2) Toont de knoppen direct onder 'Formaat'.
   3) Wisselt de hoofdfoto naar de bijpassende staande of liggende versie,
      ook nadat Shopify de galerij opnieuw heeft opgebouwd. */
(function () {
  var LIVE = 'gbm-orient--live';
  var PILL_TEXT = 'Meest gekozen';
  var lastSig = null;

  function value() { return window.__gbmOrient || 'Staand'; }

  function groupFor(labelRegex) {
    var els = document.querySelectorAll('legend, label, .variant-option__label');
    for (var i = 0; i < els.length; i++) {
      if (labelRegex.test(els[i].textContent || '')) {
        return els[i].closest('fieldset') || els[i].closest('.variant-option') || els[i].parentElement;
      }
    }
    return null;
  }

  function currentDesign() {
    var g = groupFor(/^\s*Designkleur/i);
    if (!g) return null;
    var checked = g.querySelector('input:checked');
    if (checked) {
      if (checked.value) return String(checked.value).trim();
      var lbl = checked.id ? g.querySelector('label[for="' + checked.id + '"]') : null;
      if (lbl) return (lbl.textContent || '').trim();
    }
    var pressed = g.querySelector('[aria-checked="true"], [aria-pressed="true"], .is-selected, [data-selected="true"]');
    if (pressed) return cleanText(pressed);
    return null;
  }

  /* Tekst van een knop zonder het 'Meest gekozen'-label erin. */
  function cleanText(el) {
    var t = el.textContent || '';
    return t.replace(PILL_TEXT, '').trim();
  }

  /* Zoekt in de groep de eerste knop waarvoor match() waar is en legt het
     labeltje er als los element in de fieldset bovenop. Het labeltje zit dus
     niet ín de knop: Horizon knipt de knop met overflow: clip en parkeert er
     de donkergroene selectie-achtergrond buiten beeld. Die knip moet blijven,
     anders wordt die achtergrond als donker vlak naast de knop zichtbaar. */
  function pillIn(g, match) {
    if (!g) return;
    var span = null;
    for (var c = 0; c < g.children.length; c++) {
      if (g.children[c].classList && g.children[c].classList.contains('gbm-pill')) { span = g.children[c]; break; }
    }
    var targets = g.querySelectorAll('label, button');
    var target = null;
    for (var i = 0; i < targets.length; i++) {
      if (match(cleanText(targets[i]))) { target = targets[i]; break; }
    }
    if (!target) {
      if (span) span.parentNode.removeChild(span);
      return;
    }
    if (!span) {
      span = document.createElement('span');
      span.className = 'gbm-pill';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = PILL_TEXT;
      g.appendChild(span);
    }
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    var tr = target.getBoundingClientRect();
    if (!tr.width) { span.style.display = 'none'; return; }
    span.style.display = '';
    /* Eerst op (0,0) zetten en meten waar dat uitkomt: bij een fieldset ligt
       het nulpunt onder de legenda, niet in de bovenhoek. Daarna verschuiven. */
    span.style.left = '0px';
    span.style.top = '0px';
    var sr = span.getBoundingClientRect();
    span.style.left = Math.round(tr.right - sr.left - span.offsetWidth) + 'px';
    span.style.top = Math.round(tr.top - sr.top - 9) + 'px';
  }

  /* Klein bosgroen labeltje bij de Vintage-knop (verkoopt het best) en bij
     formaat 50×70 (staat het mooist bij het ontwerp). */
  function pill() {
    if (!document.getElementById('gbm-pill-style')) {
      var st = document.createElement('style');
      st.id = 'gbm-pill-style';
      st.textContent =
        '.gbm-pill{position:absolute;z-index:5;background:#1E3A2B;color:#FAF8F4;' +
        'font-size:10px;line-height:1;letter-spacing:.02em;font-weight:500;padding:4px 8px;' +
        'border-radius:999px;white-space:nowrap;pointer-events:none;}';
      document.head.appendChild(st);
    }
    pillIn(groupFor(/^\s*Designkleur/i), function (t) {
      return t.toLowerCase() === 'vintage';
    });
    /* Formaatteksten kunnen '50×70', '50x70' of '50 × 70 cm' zijn: alleen de
       cijfers vergelijken maakt de match ongevoelig voor die schrijfwijzen. */
    pillIn(groupFor(/^\s*Formaat/i), function (t) {
      return t.replace(/\D/g, '') === '5070';
    });
  }

  /* Vingerafdruk van de gekozen variant (designkleur + formaat + lijst).
     Verandert die, dan heeft Shopify de galerij opnieuw opgebouwd. */
  function variantSig() {
    var vp = document.querySelector('variant-picker') || document.querySelector('.variant-picker');
    if (!vp) return '';
    var out = [];
    vp.querySelectorAll('input:checked').forEach(function (i) { out.push(i.value || i.id); });
    return out.join('|');
  }

  /* De hoofdgalerij van Horizon is een horizontale scrollstrook. De interne
     index van het component loopt na een hertekening uit de pas met wat er echt
     op het scherm staat, dus we sturen en lezen de scrollpositie zelf. */
  function gallery() {
    var mg = document.querySelector('media-gallery');
    var ss = mg ? mg.querySelector('slideshow-component') : null;
    var track = ss ? ss.querySelector('slideshow-slides') : null;
    if (!track) return null;
    var slides = track.querySelectorAll('slideshow-slide');
    return slides.length ? { ss: ss, track: track, slides: slides } : null;
  }

  function altOf(slide) {
    var im = slide ? slide.querySelector('img[alt]') : null;
    return im ? (im.getAttribute('alt') || '').toLowerCase() : '';
  }

  /* Welke foto staat er echt in beeld? Afgelezen aan de scrollpositie. */
  function visibleIndex(g) {
    var mid = g.track.scrollLeft + g.track.clientWidth / 2;
    for (var i = 0; i < g.slides.length; i++) {
      var left = g.slides[i].offsetLeft - g.track.offsetLeft;
      if (mid >= left && mid < left + g.slides[i].offsetWidth) return i;
    }
    return 0;
  }

  /* Schuift de strook naar de gevraagde foto. Let op: de strook staat op
     scroll-behavior: smooth, en zo'n animatie wordt door het thema afgebroken.
     Daarom springen we hard ('instant') naar de juiste plek, en herhalen we dat
     een paar keer voor het geval het thema er nog overheen gaat. */
  function goTo(g, i) {
    var left = g.slides[i].offsetLeft - g.track.offsetLeft;
    var hardSet = function () {
      var prev = g.track.style.scrollBehavior;
      g.track.style.scrollBehavior = 'auto';
      g.track.scrollLeft = left;
      g.track.style.scrollBehavior = prev;
    };
    var set = function () {
      if (Math.abs(g.track.scrollLeft - left) < 2) return;
      try { g.track.scrollTo({ left: left, behavior: 'instant' }); } catch (e) {}
      if (Math.abs(g.track.scrollLeft - left) >= 2) hardSet();
    };
    set();
    setTimeout(set, 80);
    setTimeout(set, 250);
    setTimeout(set, 600);
    setTimeout(set, 1000);
  }

  /* Zoekt de dia waarvan de alt-tekst zowel de gekozen designkleur als de
     gewenste oriëntatie bevat. Zonder kleurtreffer pakken we de eerste dia
     met de juiste oriëntatie. */
  function findSlide(g, orient) {
    var want = String(orient).toLowerCase();
    var design = (currentDesign() || '').toLowerCase();
    var fallback = -1;
    for (var i = 0; i < g.slides.length; i++) {
      var alt = altOf(g.slides[i]);
      if (!alt || alt.indexOf(want) === -1) continue;
      if (fallback === -1) fallback = i;
      if (!design || alt.indexOf(design) > -1) return i;
    }
    return fallback;
  }

  function switchMedia(orient) {
    var g = gallery();
    if (!g) return false;
    var i = findSlide(g, orient);
    if (i < 0) return false;
    goTo(g, i);
    return true;
  }

  /* Bladert de klant zelf door de galerij, dan laten we die met rust. */
  var touchedUntil = 0;
  function markTouch(e) {
    if (e.target && e.target.closest && e.target.closest('media-gallery')) {
      touchedUntil = new Date().getTime() + 2500;
    }
  }

  /* Shopify bouwt de galerij na een variantwissel meerdere keren opnieuw op en
     zet elke keer de staande variantfoto terug. In plaats van te gokken wanneer
     dat klaar is, kijken we telkens of er een staande foto staat terwijl de
     klant Liggend koos — en alleen dan corrigeren we. */
  function enforce() {
    if (value() !== 'Liggend') return;
    if (new Date().getTime() < touchedUntil) return;
    var g = gallery();
    if (!g) return;
    var vi = visibleIndex(g);
    if (altOf(g.slides[vi]).indexOf('staand') === -1) return;
    var i = findSlide(g, 'Liggend');
    if (i >= 0 && i !== vi) goTo(g, i);
  }

  /* Extra vangnet vlak na een variantwissel, voor het geval een hertekening
     geen DOM-melding oplevert waar de waarnemer op reageert. */
  function enforceSoon() {
    var delays = [200, 500, 900, 1400, 2000, 2800, 3600];
    for (var i = 0; i < delays.length; i++) setTimeout(enforce, delays[i]);
  }

  function paint(host) {
    if (!host) return;
    var v = value();
    var cur = host.querySelector('[data-gbm-current]');
    if (cur) cur.textContent = v;
    host.querySelectorAll('[data-gbm-orient]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-gbm-orient') === v ? 'true' : 'false');
    });
  }

  function syncSource() {
    var src = document.querySelector('.gbm-orient:not(.' + LIVE + ')');
    if (!src) return null;
    src.style.display = 'none';
    var input = src.querySelector('[data-gbm-input]');
    if (input) input.value = value();
    return src;
  }

  function build(src) {
    var live = src.cloneNode(true);
    live.classList.add(LIVE);
    live.removeAttribute('id');
    live.style.display = '';
    /* Het verborgen invoerveld hoort bij het formulier en blijft in het origineel. */
    var dup = live.querySelector('[data-gbm-input]');
    if (dup) dup.parentNode.removeChild(dup);
    paint(live);
    return live;
  }

  function place() {
    pill();
    var src = syncSource();
    if (!src) return;
    var g = groupFor(/^\s*Formaat/i);
    if (!g || !g.parentElement) return;
    var live = g.nextElementSibling;
    if (live && live.classList && live.classList.contains(LIVE)) {
      paint(live);
    } else {
      document.querySelectorAll('.' + LIVE).forEach(function (n) { n.parentNode.removeChild(n); });
      g.insertAdjacentElement('afterend', build(src));
    }
    var sig = variantSig();
    if (sig && lastSig !== null && sig !== lastSig) enforceSoon();
    if (sig) lastSig = sig;
    enforce();
  }

  /* Eén luisteraar op document: overleeft elk hertekenen van het thema. */
  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gbm-orient]') : null;
    if (!btn) return;
    e.preventDefault();
    var v = btn.getAttribute('data-gbm-orient');
    window.__gbmOrient = v;
    syncSource();
    paint(document.querySelector('.' + LIVE));
    paint(document.querySelector('.gbm-orient:not(.' + LIVE + ')'));
    switchMedia(v);
  }

  function boot() {
    if (!window.__gbmOrientClick) {
      window.__gbmOrientClick = true;
      document.addEventListener('click', onClick, true);
      document.addEventListener('pointerdown', markTouch, true);
    }
    place();
    /* Het labeltje wordt op maat gelegd over de knop: na het laden van de
       lettertypen en bij een andere schermbreedte even opnieuw meten. */
    setTimeout(pill, 600);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pill(); });
    if (!window.__gbmOrientResize) {
      window.__gbmOrientResize = true;
      window.addEventListener('resize', function () {
        clearTimeout(window.__gbmOrientRT);
        window.__gbmOrientRT = setTimeout(pill, 120);
      });
    }
    if (!window.__gbmOrientObs) {
      window.__gbmOrientObs = new MutationObserver(function () {
        clearTimeout(window.__gbmOrientT);
        window.__gbmOrientT = setTimeout(place, 80);
      });
      window.__gbmOrientObs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
